export default () => ({
  allergies: [],
})
